import { Box, Grid, Modal, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import manImage from "../assets/male.png"
import femaleImage from "../assets/female.png"
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import UserCard from "../features/paymentReceipt/userCard";
import { getAllCustomer } from "./customerModalApi";
import { useSelector } from "react-redux";
import { getAllCustomerDetail } from "./searchModal/api";
export const searchedElementDisplay = (item, search) => {
  return (
    !item?.mobile?.includes(search) &&
    !item?.name?.toLowerCase().includes(search?.toLowerCase()) &&
    search?.length > 0
  );
};

const CustomerModal = ({
  open, setOpen, setSelectedUser
  // userDetail,
}) => {

  const [searchName, setSearchName] = useState("")
  const [unPaidBill, setUnPaidBill] = useState([])
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const [getDataPayload, setGetDataPykoad] = useState({
    page: 1,
    pageSize: 1000,
    filter: "",
    search: "",
    filter2: "",
    search2: ""
  })
  useEffect(() => {
    console.log("dddd");
    if (open === true && userDetail) {
      getAllCustomerDetail(
        {
          ...getDataPayload,
          page: 1,
          pageSize: 1000,

          //  filter : "",
          //  search : "",
          //  filter2 : "",
          //  search2 : ""
        }, (data) => {
          //   setCollection(data)
          console.log("data detail ", data)
          setUnPaidBill(data)
        })
      // getAllCustomer({

      // buyerGroupId:0,
      // businessLineId:userDetail?.businessLineId,
      // page: 1,
      // pageSize: 1000,
      // },(res)=>{
      //     console.log("dataget",res)
      // })
      //   getCounterSalesCusomter({
      //     filter: "",
      //     search: "",
      //     page: 1,
      //     pageSize: 1000,
      //   });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {

    }
  }, [open, userDetail]);
  return (
    <Modal
      open={open}
      sx={{ zIndex: 999999 }} // Yo
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          // backgroundColor: "white",
          // width:"40%"
          background: "white",
          width: { xs: "95%", sm: "85%", md: "52%", lg: "52%", xl: "52%" },

          overflowY: "auto",
          borderRadius: "10px",
          height: "70vh",
          position: "absolute",
          left: { xs: "2%", sm: "5%", md: "25%", lg: "25%", xl: "25%" },

          top: "10%",
        }}
      >
        <Grid item xs={12}>
          <Box
            sx={{
              mt: 1,
              textAlign: "center",
              paddingX: "10px",
              paddingBottom: "10px",
            }}
          >
            <TextField
              sx={{ width: "100%" }}
              size="small"
              label="Search Customer Name"
              value={searchName}
              onChange={(e) => {
                setSearchName(e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                ),
              }}
            />
          </Box>
          {/* <CloseIcon
              sx={{
                float: "right",
                cursor: "pointer",
                color: (theme) => theme.palette.primary.main,
              }}
              onClick={() => setOpen(false)}
            /> */}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ height: "60vh", overflowY: "auto", paddingRight: "10px" }}
        >
          <Grid container>
            {unPaidBill.map((item, index) => {
              if (
                item?.name?.toLowerCase()?.includes(searchName?.toLowerCase())
              ) {
                return (
                  // <UserCard
                  //   key={"employee" + index}
                  //   data={item}
                  //   callBack={() => {
                  //     setOpen(false)
                  //     setSelectedUser(item)
                  //     // getUnpaid({
                  //     //   customerMobile: item?.mobile,
                  //     // });
                  //     // setBillData({
                  //     //   ...item,
                  //     //   customerMobile: item?.mobile,
                  //     //   customer: item?.name,
                  //     // });
                  //     // setSearch(item?.name);
                  //     // setUSerObject(item);
                  //     // callSearchApi(item?.name);
                  //     // setOpen(false);
                  //   }}
                  // />
                  <Grid
                    item
                    xs={6}
                    key={"tableListBill" + index}
                    sx={{
                      // padding: "8px 4px",
                      py: "8px",
                      px:{xs:"4px", sm:"20px"}
                    }}
                  >
                    <Box
                      onClick={() => {
                        setOpen(false);
                        setSelectedUser(item);
                      }}
                      sx={{
                        margin: "0px 10px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "start",
                        backgroundColor: "#EEEEFF",
                        alignItems: "center",
                        width: "100%",
                        fontWeight: "bold",
                        height: "70px",
                        borderRadius: "6px",
                      }}
                    >
                      <Box
                        component="img"
                        src={
                          item.gender === "female" || item.gender === "Female"
                            ? femaleImage
                            : manImage
                        }
                        sx={{
                          width: "39px",
                          borderRadius: "50%",
                          marginX: "20px",
                        }}
                      />
                      <Box>
                        {/* <Typography sx={{ fontSize: "14px", fontFamily: "'Montserrat', sans-serif", }}>
                          Emp ID: { }
                          <Typography
                            component="span"
                            color="primary"
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              fontFamily: "'Montserrat', sans-serif",

                            }}>
                            {item.employeeId ?? "NA"}
                          </Typography>
                        </Typography> */}
                        <Typography
                          color="primary"
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "16px" },

                            fontWeight: 600,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                );
              }
              return null;
            })}
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default CustomerModal;
